export enum DescriptionFormat {
  PlainText = 0,
  Markdown = 1,
}